/**
 * Gets the indexed path of intended url
 *
 * This implementation normalizes and then checks to see if the second part of the path is an index
 *
 * For example, an indexed path version of /owa with url path of /mail/0 would be /owa/0
 *
 * Remark: This method does not account for explicit logon/delegated access in url. You need to use getScopedPath for that sceanrio.
 *
 * @param rootPath a vdir like /mail (not indexed)
 * @param windowUrlPath typically location.pathname
 */
export default function getIndexedPath(rootPath: string, windowUrlPath?: string): string {
    let indexedPath = rootPath;

    if (windowUrlPath) {
        // Normalize by trimming the slashes from start and end of windowUrlPath
        let segments = windowUrlPath.split('/').filter(part => part.length);

        if (segments.length >= 2) {
            let index = parseInt(segments[1]);
            if (!isNaN(index)) {
                indexedPath += '/' + index;
            }
        }
    }

    return indexedPath;
}
